class SectorSections {
  constructor() {
    this.homeButtons = [...document.querySelectorAll('.HeaderHero .Card .Button')] || [];
    this.menuButtons = [...document.querySelectorAll('.HeaderSite ul li.homeowners, .HeaderSite ul li.trade')] || [];
    this.preHeaderButton = [...document.querySelectorAll('.PreHeader a')] || [];
    this.allButtons = [...this.homeButtons, ...this.menuButtons, ...this.preHeaderButton];

    this.allButtons.forEach(button => {
      button.addEventListener('click', this.#handleButtonClick);
    });
  }

  #handleButtonClick = (e) => {
    e.preventDefault();

    console.log(e.target);

    if (e.target.closest('.homeowners')) {
      document.cookie = "sector=homeowners; path=/";
    }

    if (e.target.closest('.trade')) {
      document.cookie = "sector=trade; path=/";
    }
    window.location = e.target.href;
  }

  #checkUrl = () => {
    if (window.location.pathname.includes('/homeowners/')) {
      document.cookie = "sector=homeowners; path=/";
    } else if (window.location.pathname.includes('/trade/')) {
      document.cookie = "sector=trade; path=/";
    } else {
      document.cookie = "sector=null; path=/";
    }
  }
}

new SectorSections();